import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useEffect } from 'react';
import { getMfeCacheBuster } from '@/common/MicroFrontEnds';
import { assetsCdnUrl } from '~/constants/environment';

export default function ActivationMfeComponent({
  onClose,
  onActivationCompletion,
  openCosignerFlow
}) {
  useEffect(() => {
    MfeLoad({
      name: 'financeactivationmodal-module',
      files: [
        [
          'CaActivationModal',
          [
            {
              component: 'default',
              default: {
                file: 'index.js',
                manifest: `${assetsCdnUrl}/activation-modal-module/assets-manifest.json?v=${getMfeCacheBuster()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);

  return (
    <MfeReactComponent
      module="CaActivationModal"
      component="default"
      onClose={onClose}
      onActivationCompletion={onActivationCompletion}
      openCosignerFlow={openCosignerFlow}
      source="srp"
    />
  );
}
